import { decodeHelpLanguage, decodeHelpText, type HelpLanguageRecord } from "@/utils/helpContentCodec";

type HelpEntryLike = {
  id?: number;
  languages?: HelpLanguageRecord[];
};

export function buildHelpDetailPagePath(helpContentId?: number | null): string {
  const id = Number(helpContentId ?? 0);
  if (!Number.isFinite(id) || id <= 0) return "";
  return `/HelpDetail/${id}`;
}

export function helpEntryHasDetailContent(entry: HelpEntryLike | null | undefined): boolean {
  if (!entry?.languages?.length) return false;
  return entry.languages.some((language) => {
    const decoded = decodeHelpLanguage(language);
    return decodeHelpText(String(decoded.detailContent ?? "")).trim().length > 0;
  });
}
